// let SallieApiUrl;
// const SallieApiUrls = {
//   production: "https://api.powerofpatients.com",
//   test: "https://test-api.powerofpatients.com",
// };

// if (window.location.hostname.startsWith("iiss")) {
//   SallieApiUrl = SallieApiUrls.production;
// } else {
//   SallieApiUrl = SallieApiUrls.test;
// }

let ApiUrl;
let environment; 
const ApiUrls = {
  production: "https://api.powerofpatients.com:8080",
  test: "https://test-api.powerofpatients.com:8080",
  temp: "https://test-api.powerofpatients.com:8081",
  development: "http://localhost:4242",
};

if (window.location.hostname.startsWith("localhost")) {
  ApiUrl = ApiUrls.development;
  environment = "development"; 

} else if(window.location.hostname.startsWith("test-iiss-v2")) {
  ApiUrl = ApiUrls.temp;
  environment = "temp"; 
  
} else if (window.location.hostname.startsWith("test")) {
  ApiUrl = ApiUrls.test;
  environment = "test"; 
//temporary for our test url

}
 else {
  ApiUrl = ApiUrls.production;
  environment = "production"; 
}

export { ApiUrl, environment }; 